import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import ContentCustom from '../../components/ContentCustom/ContentCustom';
import PageHeader from '../../components/PageHeader/PageHeader';
import { DashboardDrawer } from './DashboardDrawer';
import { MagicSearchBar } from './MagicSearchBar';
import { ShortcutsCard } from './ShortcutsCard';
import { MessagesCard } from './MessagesCard';
import { MessageCard } from './MessageCard';
import { InfoCardLeft, InfoCardRight } from './InfoCards';
import useAuthContext from '../../contexts/AuthContext';
import useAssurmaxContext from '../../contexts/AssurmaxContext';
import AwaitingInformationModal from './AwaitingInformationModal';
import QuoteCarousel from '../../components/QuoteCarousel/QuoteCarousel';

const Home = () => {
  const { t } = useTranslation();
  const [display, setDisplay] = useState(0);
  const [awaitingInformationModal, setAwaitingInformationModal] =
    useState(false);

  const { checkRightMenuAccess, user } = useAuthContext();
  const { EXEMPTION_AWAITING_INFORMATION } = useAssurmaxContext();

  useEffect(() => {
    if (EXEMPTION_AWAITING_INFORMATION > 0) {
      setAwaitingInformationModal(true);
    }
  }, [EXEMPTION_AWAITING_INFORMATION]);

  const handleModalClose = () => {
    setAwaitingInformationModal(false);
  };

  return (
    <>
      <AwaitingInformationModal
        isOpen={awaitingInformationModal}
        onClose={handleModalClose}
      />
      <PageHeader title={t('home.title')} />
      <ContentCustom style={{ padding: '0 0 24px 0' }}>
        <Row style={{ width: '100%' }}>
          {display === 0 && (
            <Col
              span={
                user?.role !== 'guests:GUEST' &&
                checkRightMenuAccess('dashboard')
                  ? 18
                  : 24
              }
            >
              {user?.role !== 'guests:GUEST' && (
                <Row>
                  <MessageCard />
                </Row>
              )}
              <Row
                style={{ marginTop: user?.role !== 'guests:GUEST' ? 0 : 19 }}
              >
                {user?.role !== 'guests:GUEST' ? <MagicSearchBar /> : ['']}
              </Row>
              <Row justify="center" gutter={[30, 24]}>
                <Col xl={24} sm={24} xs={24}>
                  <QuoteCarousel />
                </Col>
                <Col xl={12} sm={24} xs={24}>
                  <ShortcutsCard />
                </Col>
                <Col xl={12} sm={24} xs={24}>
                  <InfoCardLeft />
                </Col>
                <Col xl={24} sm={24} xs={24}>
                  <InfoCardRight />
                </Col>
              </Row>
            </Col>
          )}
          {user?.role !== 'guests:GUEST' &&
            checkRightMenuAccess('dashboard') && (
              <DashboardDrawer setDisplay={setDisplay} />
            )}
        </Row>
      </ContentCustom>
    </>
  );
};

export default Home;
